<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
}
.checkbox {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  flex-wrap: wrap;
  //min-width: 500px;
  overflow: auto;
  flex-wrap: wrap;
  .check {
    //width: 200px;
    padding-left: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }
}
.shortcut {
  text-align: left;
  .box {
    padding: 0;
    .txt {
      margin-left: 5px;
    }
    li {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 7px 15px;
      font-size: 12px;
      border-radius: 3px;
      margin-left: 10px;
    }
    li.checked {
      // background-color: #b3d8ff;
      color: #409eff;
      border: 1px #b3d8ff solid;
    }
  }
}
.param {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
  .txt {
    font-size: 13px;
    margin-left: 12px;
  }
  .tag {
    margin-left: 8px;
  }
}
.form {
  text-align: left;
}
</style>
<template>
  <div style="display: inline;">
    <div>
      <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/analyze/page" getKey="rows" :columns="columns" v-show="false"> </yi_curd_table>
      <!-- 快捷选项 -->
      <div class="shortcut">
        <ul class="box">
          <li @click="sn == '' ? '' : (paramDialog = true)">
            <i class="el-icon-document-add" :style="{ color: sn == '' ? '#909399' : '#606266' }"></i>
            <span class="txt" :style="{ color: sn == '' ? '#909399' : '#606266' }" :disabled="sn == '' ? true : false">{{ $t('xuanzegongyicanshu') }}</span>
          </li>
          <li :disabled="sn == '' ? true : false" @click="sn == '' ? '' : yt.showEditDialog('kuaijiexuanxiang', null, '80%')" style="border: 0px solid #ffff">
            <span class="txt" style="color: #409eff">{{ $t('kuaijiexuanxiang') }}</span>
          </li>
          <li v-for="(item, index) in shortcut" :key="index" :class="{ checked: index == selectIndex }" @click="selectShortcut(item, index)">
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <!-- 已选工艺参数 -->
      <div class="param">
        <span class="txt">{{ $t('yixuangongyicanshu') }}：</span>
        <el-tag size="mini" closable v-for="(item, index) in selectTag" :key="index" @close="closeTag(index)" class="tag">
          {{ item | getCNNameByCode(that) }}
        </el-tag>
      </div>
      <!-- 快捷方式表格 -->
      <el-dialog class="dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
        <template v-if="yt.editObj.action == 'kuaijiexuanxiang'">
          <div class="dialog-scroller">
            <yi_cross_select :isShowButtons="true" :isShowCaoZuo="true" :key="crossSelectKey" :isInput="false" :component="'web_process_management_analysis_analyze_table'" :max="1" :ids.sync="selectShortcutIds"> </yi_cross_select>
          </div>
        </template>
        <span slot="footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button @click="changeSelectShortcut" type="primary" size="mini">{{ $t('baocun') }}</el-button>
        </span>
      </el-dialog>
      <!-- 新增/编辑快捷选项 -->
      <el-dialog class="dialog" :title="shortcutCreateOrUpdateTitle" :visible.sync="shortcutCreateOrUpdateDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
        <el-form :model="requestForm" size="mini" class="form" ref="requestForm" :rules="requestFormRules" :label-position="labelPosition">
          <el-form-item :label="$t('suoshushebei')">
            <span>{{ this.name }}</span>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kuaijiexuanxiangmingcheng')" prop="name">
            <el-input style="width: 200px" v-model="requestForm.name"></el-input>
          </el-form-item>
        </el-form>
        <el-tabs v-model="activeTab">
          <el-tab-pane v-for="(firstItem, firstIndex) in list" :key="firstIndex" :label="firstItem.label" :name="firstItem.label">
            <div class="checkbox">
              <span v-for="(secondItem, secondIndex) in firstItem.data" :key="secondIndex" class="check">
                <el-checkbox-group :max="10" v-model="selectParameter">
                  <el-checkbox :label="secondItem">
                    {{ $t(secondItem) | getCNNameByCode($t(that)) }}
                  </el-checkbox>
                </el-checkbox-group>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="shortcutCreateOrUpdateDialog = false">{{ $t('quxiao') }} </el-button>
          <el-button type="primary" size="mini" @click="saveShortcut()">{{ $t('baocun') }}</el-button>
        </div>
      </el-dialog>
      <!-- 选择工艺参数 -->
      <el-dialog :title="$t('xuanzegongyicanshu')" :visible.sync="paramDialog" width="80%">
        <el-form :model="searchParam" :inline="true" size="mini" class="form">
          <el-form-item :label="$t('canshumiaoshu')">
            <el-input v-model="searchParam.keyword" :placeholder="$t('shuruguanjianci')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" plain>{{ $t('sousuo') }}</el-button>
            <el-button type="default" @click="reset" plain>{{ $t('chongzhi') }}</el-button>
          </el-form-item>
        </el-form>
        <div v-if="list.length>0">
          <el-tabs v-model="activeTab">
            <el-tab-pane v-for="(firstItem, firstIndex) in list" :key="firstIndex" :label="firstItem.label" :name="firstItem.label">
              <div class="checkbox">
              <span v-for="(secondItem, secondIndex) in firstItem.dict" :key="secondIndex" class="check">
                <el-checkbox-group :max="10" v-model="selectParameter">
                  <el-checkbox :label="secondItem.id">
                    {{ secondItem.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </span>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-else>
          <el-empty :description="$t('meiyoushuju')"></el-empty>
        </div>


        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="paramDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="default" size="mini" @click="shortcutCreateOrUpdateDialog = true">
            {{ $t('baocunbingchuangjianweikuaijiexuanxiang') }}
          </el-button>
          <el-button type="primary" size="mini" @click="saveTempShortcut()">{{ $t('baocun') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: 'web_process_management_analysis_analyze_table',
  props: {
    sn: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: [String, Number],
      default: ''
    },
    paramDict: {
      type: Array,
      default: () => {
        return [];
      }
    },
    equipmentId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      shortcutCreateOrUpdateDialog: false, // 快捷选项新增或编辑弹框
      paramDialog: false, //
      shortcutCreateOrUpdateTitle: this.$t('xinzengkuaijiexuanxiang'),
      activeTab: '', // 选中的tab
      selectParameter: [], // 勾选的参数
      selectIndex: -1, // 选中的快捷方式索引
      selectItem: {
        id: ''
      }, // 选中的快捷方式
      searchParam: {
        keyword: '' // 查询参数
      },
      requestForm: {
        id: '',
        name: '',
        sn: this.sn
      },
      selectTag: [], // 选中的tag
      list: [],
      shortcut: [],
      labelPosition: 'right',
      requestFormRules: {
        name: [
          {
            required: true,
            message: this.$t('qingshurukuaijiexiangmingcheng'),
            trigger: 'blur'
          }
        ]
      },
      crossSelectKey: 0,
      selectShortcutIds: '',
      selectShortcutItem: '',
      replaceIndex: 0,
      that: this,
      columns: []
    };
  },
  filters: {
    getCNNameByCode(code, that) {
      let res = that.paramDict.filter(item => {
        return item.code == code;
      });
      if (res.length > 0) {
        const unit = res[0]['unit'] == null ? '' : `(${res[0]['unit']})`;
        return res[0]['i18n'] + unit;
      } else {
        return code;
      }
    }
  },
  provide() {
    return {
      shortcut: this
    };
  },
  watch: {
    // 设备号
    sn: {
      handler(n, o) {
        if (n) {
          this.getShortCut();
        }
      },
      immediate: true
    },
    paramDict: {
      handler(n, o) {
        if (n) {
          for (let i = 0; i < n.length; i++) {
            n[i]['i18n'] = this.$t(n[i]['i18n']);
          }
          // console.log('this.paramDict',this.paramDictInt)
          console.log('mmmmddd', n);
        }
      },
      immediate: false
    },
    // 新增或编辑快捷项弹框
    shortcutCreateOrUpdateDialog: {
      handler(n, o) {
        if (n) {
          this.getParameterList();
        } else {
          this.selectParameter = [];
          this.requestForm.id = '';
          this.requestForm.name = '';
        }
      },
      immediate: false
    },
    // 选择工艺参数弹框
    paramDialog: {
      handler(n, o) {
        if (n) {
          this.initData();
        } else {
          this.selectParameter = [];
          this.requestForm.id = '';
          this.requestForm.name = '';
        }
      },
      immediate: false
    },
    selectTag: {
      handler(n, o) {
        this.$emit('selectTag', n);
      },
      immediate: false
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    getCNNameByCodeFunc(code) {
      let res = this.paramDict.filter(item => {
        return item.code == code;
      });
      if (res.length > 0) {
        const unit = res[0]['unit'] == null ? '' : `(${res[0]['unit']})`;
        return this.$t(res[0]['i18n']) + unit;
      } else {
        return code;
      }
    },
    // 数据初始化
    async initData() {
      if (this.sn == '') {
        return;
      }
      await this.getParameterList();
    },
    // 获取快捷方式
    getShortCut() {
      if (this.sn == '') {
        return;
      }
      return this.http
        .get('/web/craft/analyze/page', {
          params: {
            page: 1,
            pageSize: 5,
            sn: this.sn,
            equipmentId: this.equipmentId
          }
        })
        .then(response => {
          console.log('jjjjjj', response);
          this.shortcut = response.data.rows;
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },
    // 获取工艺参数数据
    getParameterList() {
      return this.http
        .get('/web/config/craft/template/getCreaftTemplateByEquipmentId', {
          params: {
            keyword: this.searchParam.keyword,
            equipmentId: this.equipmentId
          }
        })
        .then(response => {
          if (response.data.length > 0) {
            let data = response.data;
            if (data.length > 0) {
              let list = [];
              for (let i = 0; i < data.length; i++) {
                const ids = data[i]['data'].map(item => {
                  return item.code;
                });
                let dict = [];
                for (let j = 0; j < ids.length; j++) {
                  dict.push({
                    id: ids[j],
                    label: this.getCNNameByCodeFunc(ids[j])
                  });
                }
                list.push({
                  id: data[i]['dict'],
                  label: this.$t(this.store.state.dictJson['EQUIPMENT_CRAFT_CLASSIFICATION'][data[i]['dict']]),
                  data: data[i]['data'].map(item => {
                    return item.code;
                  }),
                  dict: dict,
                  dictInit: [...dict]
                });
              }
              this.list = list;
              console.log('this.list', this.list);
              this.activeTab = this.list.length > 0 ? this.list[0]['label'] : '';
            }
          }else {
            this.list = []
          }
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },
    // 选择工艺参数
    showParam() {
      this.paramDialog = true;
    },
    // 选择快捷方式
    selectShortcut(item, index) {
      // 取消选中
      if (index == this.selectIndex) {
        this.selectIndex = -1;
        this.selectTag = [];
        this.selectParameter = [];
      } else {
        this.selectIndex = index;
        this.selectItem = item;
        this.selectParameter = [];
        this.selectTag = item.parameter.split(',');
      }
    },
    // 删除快捷方式
    deleteShortcut(row) {
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), this.$t('jinggao'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
        .then(async () => {
          return this.http
            .post('/web/craft/analyze/delete', {
              id: row.id
            })
            .then(response => {
              ++this.crossSelectKey;
              this.getShortCut();
            });
        })
        .catch(error => {
          this.utils.errorMessage($t(error));
        });
    },
    // 临时保存快捷方式
    saveTempShortcut() {
      this.selectIndex = -1;
      this.selectTag = this.selectParameter;
      this.paramDialog = false;
    },

    // 搜索
    search() {
      for (const item of this.list) {
        item['dict'] = [...item['dictInit']];
        const result = item['dict'].filter(t => {
          return t.label.indexOf(this.searchParam.keyword.trim()) > -1;
        });
        if (result.length > 0) {
          this.activeTab = item['label'];
          item['dict'] = result;
        }
      }
    },
    // 重置查询参数
    reset() {
      this.$set(this.searchParam, 'keyword', '');
      this.getParameterList();
    },
    // 新增/更新快捷项
    saveShortcut() {
      this.$refs.requestForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.requestForm
          };
          params['parameter'] = this.selectParameter.join(',');
          params['equipmentId'] = this.equipmentId;
          let apiUrl = '';
          if (params.id) {
            apiUrl = '/web/craft/analyze/update';
          } else {
            apiUrl = '/web/craft/analyze/create';
          }
          return this.http
            .post(apiUrl, params)
            .then(response => {
              this.$message.success(this.$t('chenggong'));
              this.requestForm.name = '';
              this.shortcutCreateOrUpdateDialog = false;
              this.paramDialog = false;
              ++this.crossSelectKey;
              this.getShortCut();
            })
            .catch(error => {
              this.utils.errorMessage(this.$t(error));
            });
        }
      });
    },
    // 快捷项详情
    detailShortcut(row) {
      let data = {
        ...row
      };
      this.selectParameter = String(data.parameter).split(',');
      this.$set(this.requestForm, 'name', data.name);
      this.$set(this.requestForm, 'id', data.id);
      this.shortcutCreateOrUpdateDialog = true;
    },
    // 关闭tag标签
    closeTag(index) {
      this.selectTag = this.selectTag.filter((item, key) => {
        return key !== index;
      });
    },
    // 显示新增或更新快捷项
    addShortcut() {
      this.shortcutCreateOrUpdateDialog = true;
    },
    // 选中快捷项
    changeSelectShortcut() {
      this.yt.isShowEditDialog = false;
      if (this.selectShortcutIds) {
        return this.http
          .get('/web/craft/analyze/page', {
            params: {
              id: this.selectShortcutIds
            }
          })
          .then(response => {
            this.selectShortcutItem = response.data.rows[0];
            // 先判断当前列表有没有这个快捷项
            let current = -1;
            for (let i = 0; i < this.shortcut.length; i++) {
              if (this.shortcut[i]['id'] == this.selectShortcutItem.id) {
                current = i;
              }
            }
            if (current != -1) {
              // 默认选中
              this.selectIndex = current;
              // 回显勾选参数
              this.selectTag = this.shortcut[current]['parameter'].split(',');
            } else {
              if (this.shortcut.length == 5) {
                // 替换调列表的前五项(默认从头开始替换)
                this.shortcut[this.replaceIndex] = this.selectShortcutItem;
                if (this.replaceIndex == 4) {
                  this.replaceIndex = 0;
                } else {
                  ++this.replaceIndex;
                }
                // 默认选中
                this.selectIndex = this.replaceIndex == 0 ? 0 : this.replaceIndex - 1;
                // 回显勾选参数
                this.selectTag = this.selectShortcutItem.parameter.split(',');
              }
            }
          });
      }
    }
  }
};
</script>
